
import { Component, Vue, Prop } from 'vue-property-decorator';
@Component
export default class TrainingNav extends Vue {
    @Prop() isForwardDisabled !: boolean;
    @Prop() isBackwardsDisabled !: boolean;
    @Prop() staticButtonValue !: boolean;
}
